import React from 'react'
import MovieList from './MovieList'
import { useSelector } from 'react-redux'

const SecondaryContainer = () => {
    const movies = useSelector(store => store.movies);

    return movies.nowPlayingMovies && (
        <div className=' bg-gray-900 w-full'>
            <div className='mt-0 md:-mt-48 -pl-2 relative z-20'>
                <MovieList title={"Now Playing"} movies={movies.nowPlayingMovies} />
                <MovieList title={"Popular"} movies={movies.popularMovies} />
                <MovieList title={"Top Rated"} movies={movies.topRatedMovies} />
                <MovieList title={"Upcoming"} movies={movies.upcomingMovie} />
            </div>
        </div>
    )
}

export default SecondaryContainer
